import React from 'react';
import $ from 'jquery';
import { getUserDetail } from '../utils/helper';
import InnerPagesLoop from './InnerPagesLoop'
import { userDetailStore, translationStore } from '../config/store';




export default class HomePageComponent extends React.Component {
    constructor() {
        super();
        this.state = {
            blocks: null,
            activePage: 0,
            user: null,
            loadpage: false
        }
    }

    componentDidMount() {

        var ref = this;
        getUserDetail()
        userDetailStore.subscribe(() => {

            var user = userDetailStore.getState();

            ref.setState({ "user": user.userDetail })

            // ref.openSlide(ref)
        });

        $.get("/mantra.json", function (data) {
            // let all = { ...data.student, ...data.parent }
            let student = window.location.hostname.indexOf('localhost') != -1 ? data['student'] : data.student;
            let parent = window.location.hostname.indexOf('localhost') != -1 ? data['parent'] : data.parent;
            let all = { ...student, ...parent }
            ref.setState({ blocks: all, });
        })
    }

    componentUnMount() { }

    render() {
        var innerPages = "";
        const { blocks, loadpage, user } = this.state;
        
        if (blocks && Object.keys(blocks).length > 0) {
            innerPages = <div className=" blocks_holder_layout">
                <InnerPagesLoop data={blocks} params={this.props.match.params} />
            </div>

        }
        return (
            <div>
                {innerPages}
            </div>
        )
    }
}